module.exports = __webpack_public_path__ + "static/media/au.d8b2590e.png";